const key = "impacto.sessionToken";

export function getSessionToken(): string | null {
  return window.localStorage.getItem(key);
}

export function setSessionToken(token: string): void {
  window.localStorage.setItem(key, token);
}

export function clearSessionToken(): void {
  window.localStorage.removeItem(key);
}

// Сервер перестал принимать сессию — истёк срок или её отозвали.
//
// Браузер при этом всё ещё держит токен и считает, что человек вошёл, поэтому
// раньше вместо экрана входа показывалась карточка «Не удалось загрузить» с
// сырым «UNAUTHORIZED». Узнаёт об этом слой запросов, а переключает экран
// корень приложения, — между ними этот маленький канал.
const expiryListeners = new Set<() => void>();

export function expireSession(): void {
  if (!getSessionToken()) return;
  clearSessionToken();
  for (const listener of expiryListeners) listener();
}

export function onSessionExpired(listener: () => void): () => void {
  expiryListeners.add(listener);
  return () => expiryListeners.delete(listener);
}

// Ответ сервера «вы не вошли». Код лежит в данных ошибки tRPC; сообщение
// проверяется запасным путём, потому что без явного текста оно совпадает с
// кодом.
export function isUnauthorizedError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const code = (error as { data?: { code?: unknown } }).data?.code;
  if (code === "UNAUTHORIZED") return true;
  return (error as { message?: unknown }).message === "UNAUTHORIZED";
}
